export default function validatePagerAddress(pagerAddress)
{
	const re = /^([0-9]{1,10})@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(pagerAddress).toLowerCase());
}